import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createSlots as _createSlots, vShow as _vShow, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c2be7de"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Salvar", -1))
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_5 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_6 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_7 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Consultar CNPJ na Receita Federal", -1))
const _hoisted_9 = {
  key: 0,
  class: "ant-col ant-col-xs-24 ant-col-xl-9"
}
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_12 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_13 = ["disabled"]
const _hoisted_14 = { class: "ant-input-group-addon" }
const _hoisted_15 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_16 = { class: "ant-col ant-col-xs-24 ant-col-xl-8" }
const _hoisted_17 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_18 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_19 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_24 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_25 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_28 = { class: "ant-col ant-col-xs-24 ant-col-xl-12" }
const _hoisted_29 = { class: "ant-row" }
const _hoisted_30 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_31 = { class: "ant-row" }
const _hoisted_32 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_33 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_34 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_35 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_36 = { class: "ant-row" }
const _hoisted_37 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_38 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_39 = { class: "ant-input-group-addon ss-btn-campo" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Consultar CEP nos correios", -1))
const _hoisted_41 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_42 = { class: "ant-col ant-col-xs-24 ant-col-xl-2" }
const _hoisted_43 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_44 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_45 = { class: "ant-col ant-col-xs-24 ant-col-xl-5" }
const _hoisted_46 = { class: "ant-row" }
const _hoisted_47 = { class: "ant-col ant-col-xs-24 ant-col-xl-6" }
const _hoisted_48 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_49 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_50 = { class: "ant-input-group-addon" }
const _hoisted_51 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_52 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_53 = { class: "ant-input-group-addon" }
const _hoisted_54 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }
const _hoisted_55 = { class: "ant-input-wrapper ant-input-group" }
const _hoisted_56 = { class: "ant-input-group-addon" }
const _hoisted_57 = { class: "ant-row" }
const _hoisted_58 = { class: "ant-col ant-col-xs-24 ant-col-xl-4" }
const _hoisted_59 = { key: 0 }
const _hoisted_60 = {
  class: "ss-logo-empresa",
  style: {"background-color":"transparent"}
}
const _hoisted_61 = ["src"]
const _hoisted_62 = ["disabled"]
const _hoisted_63 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "REMOVER", -1))
const _hoisted_64 = [
  _hoisted_63
]
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { class: "ss-logo-empresa" }
const _hoisted_67 = ["disabled"]
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "ENVIAR", -1))
const _hoisted_69 = [
  _hoisted_68
]
const _hoisted_70 = { class: "ant-col ant-col-xs-24 ant-col-xl-3" }
const _hoisted_71 = { class: "ant-col ant-col-xs-24 ant-col-xl-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_campo_cnpj = _resolveComponent("campo-cnpj")!
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_campo_cpf = _resolveComponent("campo-cpf")!
  const _component_card = _resolveComponent("card")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_a_menu_item = _resolveComponent("a-menu-item")!
  const _component_a_menu = _resolveComponent("a-menu")!
  const _component_a_dropdown = _resolveComponent("a-dropdown")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_date_picker = _resolveComponent("a-date-picker")!
  const _component_campo_numerico = _resolveComponent("campo-numerico")!
  const _component_selecionar_cidade = _resolveComponent("selecionar-cidade")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_upload = _resolveComponent("a-upload")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_requisicao_modal = _resolveComponent("requisicao-modal")!
  const _component_GerenciarIESubstituicaoTributariaModal = _resolveComponent("GerenciarIESubstituicaoTributariaModal")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_modal, {
      width: "90%",
      centered: "",
      "wrap-class-name": "scroll-modal ss-modal-financeiro",
      visible: _ctx.modalBase.computedVisivel,
      "onUpdate:visible": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event))
    }, {
      title: _withCtx(() => [
        _createTextVNode(" Empresa ")
      ]),
      closeIcon: _withCtx(() => [
        _createVNode(_component_icone, { nome: "voltar" })
      ]),
      footer: _withCtx(() => [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            type: "button",
            class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.salvar()))
          }, _hoisted_2)
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_a_skeleton, {
          active: "",
          loading: _ctx.telaBase.carregando,
          paragraph: { rows: 15 }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form, { layout: "vertical" }, {
              default: _withCtx(() => [
                _createVNode(_component_card, { titulo: "DADOS PRINCIPAIS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", _hoisted_4, [
                        _createVNode(_component_a_form_item, {
                          label: "Pessoa",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_select, {
                              value: _ctx.stateModal.empresa.tipoPessoa,
                              "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.stateModal.empresa.tipoPessoa) = $event)),
                              placeholder: "Selecione",
                              style: {"width":"100%"},
                              disabled: true,
                              options: _ctx.stateModal.listaTipoPessoa
                            }, null, 8, ["value", "options"])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_5, [
                        (_ctx.stateModal.empresa.tipoPessoa === _ctx.ETipoPessoa.Juridica)
                          ? (_openBlock(), _createBlock(_component_a_form_item, {
                              key: 0,
                              label: "CNPJ",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("span", _hoisted_6, [
                                  _createVNode(_component_campo_cnpj, {
                                    valor: _ctx.stateModal.empresa.cpfCnpj,
                                    "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.stateModal.empresa.cpfCnpj) = $event)),
                                    onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.consultaCNPJ($event.target.value))),
                                    disabled: true
                                  }, null, 8, ["valor"]),
                                  _createElementVNode("span", _hoisted_7, [
                                    _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                      title: _withCtx(() => [
                                        _hoisted_8
                                      ]),
                                      default: _withCtx(() => [
                                        _createElementVNode("a", {
                                          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.consultaCNPJ(_ctx.stateModal.empresa.cpfCnpj)))
                                        }, [
                                          _createVNode(_component_icone, {
                                            style: {"height":"12px","width":"60px","margin-left":"-16px"},
                                            nome: "receita-federal"
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_a_form_item, {
                              key: 1,
                              label: "CPF",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_campo_cpf, {
                                  valor: _ctx.stateModal.empresa.cpfCnpj,
                                  "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.stateModal.empresa.cpfCnpj) = $event)),
                                  disabled: true
                                }, null, 8, ["valor"])
                              ]),
                              _: 1
                            }))
                      ]),
                      (_ctx.stateModal.empresa.tipoPessoa === _ctx.ETipoPessoa.Juridica)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createVNode(_component_a_form_item, {
                              label: "Razão social",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _withDirectives(_createElementVNode("input", {
                                  type: "text",
                                  maxlength: "250",
                                  class: "ant-input",
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.stateModal.empresa.razaoSocial) = $event))
                                }, null, 512), [
                                  [_vModelText, _ctx.stateModal.empresa.razaoSocial]
                                ])
                              ]),
                              _: 1
                            })
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", {
                        class: _normalizeClass(_ctx.stateModal.empresa.tipoPessoa === _ctx.ETipoPessoa.Juridica ? 'ant-col ant-col-xs-24 ant-col-xl-7' : 'ant-col ant-col-xs-24 ant-col-xl-16')
                      }, [
                        _createVNode(_component_a_form_item, {
                          label: _ctx.stateModal.empresa.tipoPessoa === _ctx.ETipoPessoa.Juridica ? 'Nome fantasia' : 'Nome completo',
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "60",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.stateModal.empresa.nomeFantasia) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.stateModal.empresa.nomeFantasia]
                            ])
                          ]),
                          _: 1
                        }, 8, ["label"])
                      ], 2)
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_tabs, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_a_tab_pane, {
                      key: "1",
                      tab: "INSCRIÇÕES"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("div", _hoisted_11, [
                                _createVNode(_component_a_form_item, {
                                  label: "Inscrição Estadual",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_12, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        maxlength: "14",
                                        class: "ant-input",
                                        disabled: _ctx.stateModal.empresa.isentoInscricaoEstadual,
                                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.stateModal.empresa.inscricaoEstadual) = $event))
                                      }, null, 8, _hoisted_13), [
                                        [_vModelText, _ctx.stateModal.empresa.inscricaoEstadual]
                                      ]),
                                      _createElementVNode("span", _hoisted_14, [
                                        _createVNode(_component_a_checkbox, {
                                          checked: _ctx.stateModal.empresa.isentoInscricaoEstadual,
                                          "onUpdate:checked": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.stateModal.empresa.isentoInscricaoEstadual) = $event)),
                                          onClick: _ctx.comportamentoInscricaoEstadual
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("Isento")
                                          ]),
                                          _: 1
                                        }, 8, ["checked", "onClick"])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_15, [
                                _createVNode(_component_a_form_item, {
                                  label: "Inscrição Municipal",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      maxlength: "14",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.stateModal.empresa.inscricaoMunicipal) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.stateModal.empresa.inscricaoMunicipal]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createVNode(_component_a_form_item, {
                                  label: "IE Substitutos Tributários",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_17, [
                                      _createVNode(_component_a_dropdown, null, {
                                        overlay: _withCtx(() => [
                                          _createVNode(_component_a_menu, null, {
                                            default: _withCtx(() => [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stateModal.empresa.ieSubstituicaoTributaria, (ieSubstituicaoTributaria, index) => {
                                                return (_openBlock(), _createBlock(_component_a_menu_item, { key: index }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(_toDisplayString(_ctx.obtemSiglaEstado(ieSubstituicaoTributaria.codigoEstado)) + " - " + _toDisplayString(ieSubstituicaoTributaria.inscricaoEstadual), 1)
                                                  ]),
                                                  _: 2
                                                }, 1024))
                                              }), 128))
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_select, {
                                            "not-found-content": null,
                                            placeholder: _ctx.obtemTextoIESubstituicao(),
                                            class: "ss-select-completo-botao",
                                            "show-arrow": _ctx.stateModal.empresa.ieSubstituicaoTributaria.length > 0
                                          }, null, 8, ["placeholder", "show-arrow"])
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("span", _hoisted_18, [
                                        _createElementVNode("a", {
                                          onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.gerenciarIESubstituicao && _ctx.gerenciarIESubstituicao(...args)))
                                        }, [
                                          _createVNode(_component_icone, { nome: "ordenar-lista" })
                                        ])
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_19, [
                                _createVNode(_component_a_form_item, {
                                  label: "Inscrição SUFRAMA",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      maxlength: "9",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.stateModal.empresa.inscricaoSuframa) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.stateModal.empresa.inscricaoSuframa]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "2",
                      tab: "ATIVIDADE/TRIBUTAÇÃO"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createVNode(_component_card, {
                              titulo: "ATIVIDADE",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("div", _hoisted_23, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Tipo de atividade",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.stateModal.empresa.tipoAtividade,
                                          "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.stateModal.empresa.tipoAtividade) = $event)),
                                          optionFilterProp: "label",
                                          "show-search": true,
                                          placeholder: "Selecione",
                                          style: {"width":"100%"},
                                          options: _ctx.stateModal.listaTipoAtividade
                                        }, null, 8, ["value", "options"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_24, [
                                    _createVNode(_component_a_form_item, {
                                      label: "CNAE - Principal",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.stateModal.empresa.cnaePrincipal,
                                          "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.stateModal.empresa.cnaePrincipal) = $event)),
                                          "show-search": "",
                                          allowClear: true,
                                          placeholder: "Digite para selecionar um CNAE",
                                          style: {"width":"100%"},
                                          "filter-option": false,
                                          "not-found-content": _ctx.telaBase.fetching ? undefined : null,
                                          options: _ctx.stateModal.listaCNAES,
                                          onSearch: _cache[15] || (_cache[15] = ($event: any) => (_ctx.pesquisarCNAE($event, false)))
                                        }, _createSlots({ _: 2 }, [
                                          (_ctx.telaBase.fetching)
                                            ? {
                                                name: "notFoundContent",
                                                fn: _withCtx(() => [
                                                  _createVNode(_component_a_spin, { size: "small" })
                                                ]),
                                                key: "0"
                                              }
                                            : undefined
                                        ]), 1032, ["value", "not-found-content", "options"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createVNode(_component_card, {
                              titulo: "TRIBUTAÇÃO",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_26, [
                                  _createElementVNode("div", _hoisted_27, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Regime tributário",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.stateModal.empresa.regimeTributario,
                                          "onUpdate:value": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.stateModal.empresa.regimeTributario) = $event)),
                                          optionFilterProp: "label",
                                          "show-search": true,
                                          placeholder: "Selecione",
                                          style: {"width":"100%"},
                                          options: _ctx.stateModal.listaRegimeTributario
                                        }, null, 8, ["value", "options"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_28, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Regime Especial de Tributação",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_select, {
                                          value: _ctx.stateModal.empresa.regimeTributarioEspecial,
                                          "onUpdate:value": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.stateModal.empresa.regimeTributarioEspecial) = $event)),
                                          optionFilterProp: "label",
                                          "show-search": true,
                                          placeholder: "Selecione",
                                          style: {"width":"100%"},
                                          options: _ctx.stateModal.listaRegimeTributarioEspecial
                                        }, null, 8, ["value", "options"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _withDirectives(_createElementVNode("div", _hoisted_29, [
                          _createElementVNode("div", _hoisted_30, [
                            _createVNode(_component_card, {
                              titulo: "SIMPLES NACIONAL",
                              class: "ss-margin-campos"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Data de adesão",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_a_date_picker, {
                                          value: _ctx.stateModal.dataAdesaoSimples,
                                          "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.stateModal.dataAdesaoSimples) = $event)),
                                          onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.stateModal.empresa.simplesNacional.dataAdesao = _ctx.UtilitarioData.converterDataJson(_ctx.stateModal.dataAdesaoSimples))),
                                          format: _ctx.UtilitarioData.formatoDataDiaMesAno,
                                          style: {"width":"100%"}
                                        }, null, 8, ["value", "format"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_33, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Receita Bruta em 12 Meses",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          monetario: true,
                                          valor: _ctx.stateModal.empresa.simplesNacional.receitaBruta,
                                          "onUpdate:valor": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.stateModal.empresa.simplesNacional.receitaBruta) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_34, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Alíquota ICMS",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          percentual: true,
                                          valor: _ctx.stateModal.empresa.simplesNacional.aliquotaIcms,
                                          "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.stateModal.empresa.simplesNacional.aliquotaIcms) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _createElementVNode("div", _hoisted_35, [
                                    _createVNode(_component_a_form_item, {
                                      label: "Alíquota ISS",
                                      class: "ss-margin-campos"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_campo_numerico, {
                                          percentual: true,
                                          valor: _ctx.stateModal.empresa.simplesNacional.aliquotaIss,
                                          "onUpdate:valor": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.stateModal.empresa.simplesNacional.aliquotaIss) = $event))
                                        }, null, 8, ["valor"])
                                      ]),
                                      _: 1
                                    })
                                  ])
                                ])
                              ]),
                              _: 1
                            })
                          ])
                        ], 512), [
                          [_vShow, _ctx.verificaEmpresaSimples()]
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_a_tab_pane, {
                      key: "3",
                      tab: "ENDEREÇO"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_card, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_36, [
                              _createElementVNode("div", _hoisted_37, [
                                _createVNode(_component_a_form_item, {
                                  label: "CEP",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_38, [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.stateModal.empresa.endereco.cep) = $event)),
                                        onBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.consultaCEP(($event.target as HTMLInputElement).value)))
                                      }, null, 544), [
                                        [_vModelText, _ctx.stateModal.empresa.endereco.cep],
                                        [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraCEP]
                                      ]),
                                      _createElementVNode("span", _hoisted_39, [
                                        _createVNode(_component_a_tooltip, { placement: "topRight" }, {
                                          title: _withCtx(() => [
                                            _hoisted_40
                                          ]),
                                          default: _withCtx(() => [
                                            _createElementVNode("button", {
                                              onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.consultaCEP(_ctx.stateModal.empresa.endereco.cep))),
                                              class: "ant-btn ant-btn-block ant-btn-primary ss-btn-icone-campo"
                                            }, [
                                              _createVNode(_component_icone, { nome: "cep" })
                                            ])
                                          ]),
                                          _: 1
                                        })
                                      ])
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_41, [
                                _createVNode(_component_a_form_item, {
                                  label: "Endereço/Avenida/Rua",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      maxlength: "60",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.stateModal.empresa.endereco.logradouro) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.stateModal.empresa.endereco.logradouro]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_42, [
                                _createVNode(_component_a_form_item, {
                                  label: "Número",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      maxlength: "10",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.stateModal.empresa.endereco.numero) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.stateModal.empresa.endereco.numero]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_43, [
                                _createVNode(_component_a_form_item, {
                                  label: "Complemento",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      maxlength: "60",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.stateModal.empresa.endereco.complemento) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.stateModal.empresa.endereco.complemento]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_44, [
                                _createVNode(_component_a_form_item, {
                                  label: "Bairro",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "text",
                                      maxlength: "60",
                                      class: "ant-input",
                                      "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.stateModal.empresa.endereco.bairro) = $event))
                                    }, null, 512), [
                                      [_vModelText, _ctx.stateModal.empresa.endereco.bairro]
                                    ])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _createElementVNode("div", _hoisted_45, [
                                _createVNode(_component_a_form_item, {
                                  label: "Cidade/Estado",
                                  class: "ss-margin-campos"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_selecionar_cidade, {
                                      codigoSelecionado: _ctx.stateModal.empresa.endereco.codigoCidade,
                                      "onUpdate:codigoSelecionado": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.stateModal.empresa.endereco.codigoCidade) = $event)),
                                      apresentarEstado: true
                                    }, null, 8, ["codigoSelecionado"])
                                  ]),
                                  _: 1
                                })
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "CONTATO/OUTROS" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("div", _hoisted_47, [
                        _createVNode(_component_a_form_item, {
                          label: "Contato",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "255",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.stateModal.empresa.contato) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.stateModal.empresa.contato]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_48, [
                        _createVNode(_component_a_form_item, {
                          label: "Telefone",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_49, [
                              _createElementVNode("span", _hoisted_50, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone",
                                  nome: "telefone"
                                })
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.stateModal.empresa.telefone) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.stateModal.empresa.telefone],
                                [_directive_maska, _ctx.UtilitarioMascara.formatoMascaraTelefoneFixoCelular]
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_51, [
                        _createVNode(_component_a_form_item, {
                          label: "Site",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_52, [
                              _createElementVNode("span", _hoisted_53, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone",
                                  nome: "site"
                                })
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "255",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.stateModal.empresa.site) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.stateModal.empresa.site]
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_54, [
                        _createVNode(_component_a_form_item, {
                          label: "E-mail",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_55, [
                              _createElementVNode("span", _hoisted_56, [
                                _createVNode(_component_icone, {
                                  class: "ss-icone",
                                  nome: "email"
                                })
                              ]),
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                maxlength: "250",
                                class: "ant-input",
                                "onUpdate:modelValue": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.stateModal.empresa.email) = $event))
                              }, null, 512), [
                                [_vModelText, _ctx.stateModal.empresa.email]
                              ])
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_card, { titulo: "PERSONALIZAÇÃO" }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_57, [
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_a_form_item, {
                          label: "Logo",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            (_ctx.stateModal.empresa.logo)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_59, [
                                  _createElementVNode("div", _hoisted_60, [
                                    (_ctx.stateModal.carrengadoLogo)
                                      ? (_openBlock(), _createBlock(_component_a_spin, {
                                          key: 0,
                                          size: "large"
                                        }))
                                      : (_openBlock(), _createElementBlock("img", {
                                          key: 1,
                                          src: _ctx.stateModal.empresa.logo,
                                          alt: "Logo empresa"
                                        }, null, 8, _hoisted_61))
                                  ]),
                                  _createElementVNode("button", {
                                    onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.removerLogo && _ctx.removerLogo(...args))),
                                    type: "button",
                                    disabled: _ctx.stateModal.carrengadoLogo,
                                    class: "ant-btn ant-btn-sm ant-btn-primary ant-btn-dangerous ss-btn-logo-empresa"
                                  }, _hoisted_64, 8, _hoisted_62)
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                  _createElementVNode("div", _hoisted_66, [
                                    (_ctx.stateModal.carrengadoLogo)
                                      ? (_openBlock(), _createBlock(_component_a_spin, {
                                          key: 0,
                                          size: "large"
                                        }))
                                      : (_openBlock(), _createBlock(_component_icone, {
                                          key: 1,
                                          style: {"font-size":"30px","color":"#8d8d8d"},
                                          nome: "imagem"
                                        }))
                                  ]),
                                  _createVNode(_component_a_upload, {
                                    "file-list": _ctx.stateModal.listaArquivo,
                                    "onUpdate:fileList": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.stateModal.listaArquivo) = $event)),
                                    "show-upload-list": false,
                                    multiple: false,
                                    accept: 'image/*',
                                    "before-upload": _ctx.enviarLogo
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        disabled: _ctx.stateModal.carrengadoLogo,
                                        class: "ant-btn ant-btn-sm ant-btn-primary ss-btn-logo-empresa"
                                      }, _hoisted_69, 8, _hoisted_67)
                                    ]),
                                    _: 1
                                  }, 8, ["file-list", "before-upload"])
                                ]))
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_70, [
                        _createVNode(_component_a_form_item, {
                          label: "Código de exibição",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "20",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.stateModal.empresa.codigoExibicao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.stateModal.empresa.codigoExibicao]
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_71, [
                        _createVNode(_component_a_form_item, {
                          label: "Nome exibição",
                          class: "ss-margin-campos"
                        }, {
                          default: _withCtx(() => [
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              maxlength: "60",
                              class: "ant-input",
                              "onUpdate:modelValue": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.stateModal.empresa.nomeExibicao) = $event))
                            }, null, 512), [
                              [_vModelText, _ctx.stateModal.empresa.nomeExibicao]
                            ])
                          ]),
                          _: 1
                        })
                      ])
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["loading"]),
        _createVNode(_component_requisicao_modal, {
          visivel: _ctx.modalBase.exibirRequisicaoModal,
          "onUpdate:visivel": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.modalBase.exibirRequisicaoModal) = $event)),
          retornoRequisicao: _ctx.modalBase.retornoRequisicao
        }, null, 8, ["visivel", "retornoRequisicao"]),
        _createVNode(_component_GerenciarIESubstituicaoTributariaModal, {
          "inscricoes-substituicao-tributaria": _ctx.stateModal.empresa.ieSubstituicaoTributaria,
          "onUpdate:inscricoesSubstituicaoTributaria": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.stateModal.empresa.ieSubstituicaoTributaria) = $event)),
          visivel: _ctx.stateModal.exibirGerenciadorIESubstituicao,
          "onUpdate:visivel": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.stateModal.exibirGerenciadorIESubstituicao) = $event)),
          "lista-estados": _ctx.listaDtoEstados,
          onAtualizarInscricoesSubstituicaoTributaria: _ctx.atualizarInscricoesSubstituicaoTributaria
        }, null, 8, ["inscricoes-substituicao-tributaria", "visivel", "lista-estados", "onAtualizarInscricoesSubstituicaoTributaria"])
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}